import axios from '@/utils/axios';

const validate = (token) => axios.get(`/sources/validation/${token}`);
const finalizeOauth = (token, detail) => axios.patch(`/sources/oauth/${token}`, detail);

export default {
  validate,
  finalizeOauth,
};
